import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Input, Button } from '@klaro7/ui';

import { extractErrorMessage } from '@/lib/api';
import { useServicesSettings, useUpdateServicesSettings } from '@/features/settings/hooks/useServicesSettings';

export function AdminRevenueConfigPage() {
  const { data: settings } = useServicesSettings();
  const updateMutation = useUpdateServicesSettings();

  const [commissionPct, setCommissionPct] = useState(45);
  const [fixedFeePerCall, setFixedFeePerCall] = useState(0.75);

  useEffect(() => {
    if (settings) {
      setCommissionPct(Math.round((settings.payout?.commissionRate ?? 0.45) * 100));
      setFixedFeePerCall(settings.payout?.fixedFeePerCall ?? 0.75);
    }
  }, [settings]);

  async function handleSavePayout() {
    try {
      await updateMutation.mutateAsync({
        payout: {
          commissionRate: commissionPct / 100,
          fixedFeePerCall,
        },
      });
      toast.success('Commissioni consulenze salvate con successo');
    } catch (err) {
      toast.error(extractErrorMessage(err));
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-900">Revenue</h1>
        <p className="mt-1 text-sm text-neutral-600">Configurazione compensi e commissioni</p>
      </div>

      {/* Configurazione */}
      <div className="overflow-hidden rounded-xl border border-neutral-200 bg-white">
        <div className="flex items-center gap-3 border-b border-neutral-100 bg-neutral-50 px-5 py-3.5">
          <svg className="h-5 w-5 text-neutral-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6v12m-4.5-9.75a2.25 2.25 0 012.25-2.25h4.5a2.25 2.25 0 012.25 2.25c0 .966-.63 1.784-1.5 2.063m-6 3.687c0 .966.63 1.784 1.5 2.063m0 0a2.25 2.25 0 002.25 2.25h.75m0-4.5v4.5" />
          </svg>
          <div>
            <h3 className="text-sm font-semibold text-neutral-700">Commissioni consulenze</h3>
            <p className="text-xs text-neutral-600">
              Compenso professionista = (importo speso × quota professionista) − commissione, mai sotto zero. Sulle
              chiamate fino a 2 minuti la commissione non si applica, e allungare la chiamata non può far scendere il
              compenso. Vale per i nuovi compensi.
            </p>
          </div>
        </div>
        <div className="space-y-4 p-5">
          <div className="grid gap-4 md:grid-cols-2">
            <Input
              label="Quota professionista (%)"
              type="number"
              min={0}
              max={100}
              step={1}
              value={String(commissionPct)}
              onChange={(e) => setCommissionPct(Number(e.target.value))}
            />
            <Input
              label="Commissione piattaforma per chiamata risposta (€)"
              type="number"
              min={0}
              step={0.01}
              value={String(fixedFeePerCall)}
              onChange={(e) => setFixedFeePerCall(Number(e.target.value))}
            />
          </div>
          <div className="flex justify-end border-t border-neutral-100 pt-4">
            <Button onClick={handleSavePayout} loading={updateMutation.isPending}>
              Salva commissioni
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
